import packageJson from '../../../../package.json';

export const ORYA_TOUR_KEY = 'orya';

/** Tour Orya ativo se enabled no package, tourKey=orya e version === app version */
export function getOryaTourSettings() {
  const tourConfig = packageJson.tourVirtual || {};
  const tourKey = String(tourConfig.tourKey ?? ORYA_TOUR_KEY).trim();
  const enabled = tourConfig.enabled === true && tourKey === ORYA_TOUR_KEY;
  const configVersion = String(tourConfig.version ?? '').trim();
  const appVersion = String(packageJson.version ?? '').trim();
  const versionMatch = Boolean(configVersion && configVersion === appVersion);

  return {
    active: enabled && versionMatch,
    tourVersion: versionMatch ? configVersion : null,
    tourKey: ORYA_TOUR_KEY,
  };
}
